<template>
    <form>
        <ModalEdition :isEdition="params.id != null" :modalId="'modalEditMouvementStock'" ref="modalMouvementStockRef"
            @save="saveMouvementStock">
            <div class="form">
                <div class="form-group">
                    <label for="mouvementStock_quantite">Quantité</label>
                    <input type="number" class="form-control" id="mouvementStock_libelle"
                        v-model="mouvementStock.quantite" />
                </div>
                <div class="form-group">
                    <label for="mouvementStock_traitement">Traitement</label>
                    <select v-model="mouvementStock.typeTraitement" class="form-select">
                        <option v-for="traitement in typeTraitement" :value="traitement" :key="traitement">
                            {{ traitement }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="mouvementStock_date">Date</label>
                    <input type="date" class="form-control" id="mouvementStock_date" v-model="mouvementStock.date" />
                </div>

                <div class="form-group">
                    <label for="mouvementStock_fournisseur">Fournisseur</label>
                    <select v-model="mouvementStock.fournisseur.id" class="form-select">
                        <option v-for="fourn in fournisseur" :value="fourn.id" :key="fourn.id">
                            {{ fourn.libelle }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="mouvementStock_stock">Stock</label>
                    <input type="text" class="form-control" :value="stock.zoneStockage.libelle" disabled />
                </div>
            </div>
        </ModalEdition>
    </form>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';


export default {
    name: 'MouvementStockEdit',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            mouvementStock: {
                fournisseur: {},
                stock: {},
            },
            stock: {
                zoneStockage: {
                    libelle: "",
                }
            },
            fournisseur: {},
            typeTraitement: ['IN', 'OUT'],
        }
    },
    mounted() {
        this.getFournisseur();
    },
    methods: {
        getMouvementStock(id) {
            Axios.get('/mouvementStock/' + id).then(res => {
                this.mouvementStock = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des mouvements de stocks :', err);
            });
        },

        getFournisseur() {
            Axios.get('/fournisseur').then(res => {
                this.fournisseur = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des fournisseurs :', err);
            });
        },
        getStock(id) {
            Axios.get('/stock/' + id).then(res => {
                this.stock = res.data;
            }).catch(err => {
                console.error('Erreur lors du chargement des stocks :', err);
            });
        },
        saveMouvementStock() {
            this.errors = [];
            if (this.mouvementStock.quantite == null) {
                this.errors.push({ message: "La quantite est requise" });
            }

            if (this.errors.length) {
                this.$refs.modalMouvementStockRef.errorMessage(this.errors)
                return;
            }

            this.mouvementStock.stock.id = this.stock.id;

            Axios.post('/mouvementStock', this.mouvementStock)
                .then(() => {
                    this.$refs.modalMouvementStockRef.closeModal();
                    this.$emit('saved');
                })
                .catch(err => {
                    console.error('Erreur lors de la sauvegarde du mouvement de stock :', err);
                });
        }
    },
    watch: {
        params: {
            handler(params) {

                if (params.idStock != null) {
                    this.getStock(params.idStock);
                }

                if (params.id != null) {
                    this.getMouvementStock(params.id);
                } else {
                    this.mouvementStock.fournisseur = {};
                    this.mouvementStock.quantite = null;
                    this.mouvementStock.traitement = null;
                    this.mouvementStock.date = null;
                }
            },
            deep: true,
        },
    },

}
</script>

<style>
.form {
    max-width: 300px;
    margin: 0 auto;
}

.formGroup {
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}
</style>
